import React from "react";

const accessDeniedStyles = `
  .access-denied-fullscreen {
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg, #004263 0%, #42b0d5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
    font-family: "Maersk Text", Arial, sans-serif;
    color: #004263;
    z-index: 999999;
    overflow: auto;
  }

  .access-denied-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 28px rgba(0, 66, 99, 0.16);
    padding: clamp(2rem, 4vw, 2.75rem) 2.5rem;
    max-width: 580px;
    width: 100%;
    text-align: center;
  }

  .denied-icon-placeholder {
    width: clamp(5rem, 15vw, 8rem);
    height: clamp(5rem, 15vw, 8rem);
    background: #fcb7be;
    border-radius: 50%;
    margin: 0 auto 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: clamp(2.5rem, 8vw, 4rem);
    color: white;
    font-weight: bold;
  }

  .denied-title {
    font-size: clamp(1.7rem, 4.5vw, 2.3rem);
    font-weight: 700;
    margin-bottom: 0.5rem;
    color: #004263;
  }

  .denied-message {
    font-size: clamp(1rem, 2.8vw, 1.15rem);
    line-height: 1.55;
    margin-bottom: 1.25rem;
    color: #004263;
  }

  .action-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
  }

  .denied-details {
    text-align: left;
    margin: 1rem 0;
    padding: 0.65rem 0.75rem;
    background: #f4f8fb;
    border: 1px solid #e2ebf1;
    border-radius: 8px;
  }

  .denied-detail-row {
    margin: 0.2rem 0;
    font-size: 10px;
    color: #003a56;
    line-height: 1.4;
    text-align: left;
  }

  .denied-detail-label {
    font-weight: 700;
    margin-right: 0.35rem;
  }

  .custom-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.8rem 1.6rem;
    font-size: 1rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #42b0d5;
    color: #004263;
    font-family: "Maersk Text", Arial, sans-serif;
  }

  .custom-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 66, 99, 0.18);
    background: #3399bf;
  }

  .support-hint {
    margin-top: 2rem;
    font-size: 0.9rem;
    opacity: 0.8;
    color: #004263;
  }
`;

const STYLE_ID = "access-denied-styles-dtr";

if (
  typeof window !== "undefined" &&
  !document.head.querySelector(`style[data-style-id="${STYLE_ID}"]`)
) {
  const style = document.createElement("style");
  style.setAttribute("data-style-id", STYLE_ID);
  style.textContent = accessDeniedStyles;
  document.head.appendChild(style);
}

const AccessDenied = ({
  onRequestAccess,
  deniedReason = "Your request does not meet current access policy requirements.",
  deniedDate = new Date().toLocaleDateString(),
}) => {
  return (
    <div className="access-denied-fullscreen">
      <div className="access-denied-card">
        <div className="denied-icon-placeholder">!</div>
        <h1 className="denied-title">Access Denied</h1>
        <p className="denied-message">
          Sorry, you do not have permission to view this page.
          <br />
          
        </p>
        <div className="denied-details">
          <p className="denied-detail-row">
            <span className="denied-detail-label">Access Denied Reason:</span>
            <span>{deniedReason}</span>
          </p>
          <p className="denied-detail-row">
            <span className="denied-detail-label">Access Denied Date:</span>
            <span>{deniedDate}</span>
          </p>
        </div>
        <div className="action-buttons">
          {onRequestAccess && (
            <button className="custom-button" onClick={onRequestAccess}>
              Request Access
            </button>
          )}
        </div>
        <p className="support-hint">Powered by GDA | IONIS</p>
      </div>
    </div>
  );
};

export default AccessDenied;
